import { Injectable } from '@angular/core';

type Unit = "kg" | "g" | "mg" | "lb" | "oz";

@Injectable({
  providedIn: 'root'
})
export class UnitConverterService {
  // Dizionario di conversione con fattori di scala rispetto a kg (unità base)
  private conversionFactors: Record<Unit, number> = {
    kg: 1.0,       // Kilogrammi come unità base
    g: 1000.0,     // Grammi
    mg: 1_000_000, // Milligrammi
    lb: 2.20462,   // Libbre
    oz: 35.274     // Once
  };

  convert(value: number, fromUnit: string, toUnit: string): number {
    fromUnit = fromUnit.toLowerCase();
    toUnit = toUnit.toLowerCase();
    if (!(fromUnit in this.conversionFactors)) {
      return value;
      //throw new Error(`Unità di misura non riconosciuta: ${fromUnit}`);
    }
    if (!(toUnit in this.conversionFactors)) {
      return value;
      //throw new Error(`Unità di misura non riconosciuta: ${toUnit}`);
    }
    // Conversione a unità base (kg)
    const valueInBaseUnit = value / this.conversionFactors[fromUnit];
    // Conversione all'unità desiderata
    const convertedValue = valueInBaseUnit * this.conversionFactors[toUnit];
    return convertedValue;
  }
}
